import type { AnimationI } from "tweenly"
/**
 * Compares two animations for sorting purposes.
 * Primary sort: by start-time (delay) ascending
 * Secondary sort: by tween name for consistency when delays are equal
 */
export const compareAnimations = (
    animation1: AnimationI | undefined,
    animation2: AnimationI | undefined
): number => {
    if (animation1 && animation2) {
        // Primary sort: by start-time (delay) ascending
        const delayDiff = animation1.delay - animation2.delay
        if (delayDiff !== 0) {
            return delayDiff
        }

        // Secondary sort: by tween name for consistency when delays are equal
        if (animation1.tween.name < animation2.tween.name) {
            return -1
        }
        if (animation1.tween.name > animation2.tween.name) {
            return 1
        }
        return 0
    }
    return 0
}
